export function GetStdDate(aDate) {
  // YYYYMMDD
  var month = aDate.getMonth();
  var monthS;
  var m1 = month + 1;
  if (m1 < 10) monthS = "0" + m1;
  else monthS = m1.toString();
  var day = aDate.getDate();
  if (day < 10) day = "0" + day;
  var dateString = aDate.getFullYear() + monthS + day;
  return dateString;
}

/** YYYYMMDDHHmm in UTC. Matches backend strftime("%Y%m%d%H%M"). */
export function GetStdDateTimeUTC(date = new Date()) {
  const pad = n => String(n).padStart(2, "0");
  return (
    date.getUTCFullYear() +
    pad(date.getUTCMonth() + 1) +
    pad(date.getUTCDate()) +
    pad(date.getUTCHours()) +
    pad(date.getUTCMinutes())
  );
}
